import { useMutation, useQueryClient } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedMutationOptions } from 'queries/types';
import { isOkResponse, throwResponseError } from 'queries/utils';

export function useStartTrial(
    options?: UseExposedMutationOptions<Api.V3.License.StartTrial.Response, Error, Api.V3.License.StartTrial.Payload>
) {
    const notify = useNotify();
    const queryClient = useQueryClient();

    return useMutation<Api.V3.License.StartTrial.Response, Error, Api.V3.License.StartTrial.Payload>({
        ...options,
        mutationFn: async () => {
            const response = await new RequestAgent()
                .csrf(Api.V3.License.StartTrial.Csrf())
                .post(Api.V3.License.StartTrial.Endpoint(), {});

            if (isOkResponse(response)) {
                notify.openNotification({ level: 'success', message: `Trial successfully activated` });
                return queryClient.invalidateQueries({ queryKey: Api.V4.User.Info.QueryKey() });
            } else {
                throwResponseError(response);
            }
        },
        onError: (error, ...rest) => {
            notify.openNotification({ level: 'error', message: error.message });
            options?.onError?.(error, ...rest);
        }
    });
}
